// let ENVE_DEV = true;
const baseUrl = {
  // wm: (ENVE_DEV ? '/api' : '') + '/xmail/wm/v1/',
  // udcd: (ENVE_DEV ? '/api' : '')+ '/xmail/udcd/v1/'
  wm: '/xmail/wm/v1',
  udcd: '/xmail/udcd/v1/'
};
export default baseUrl;



// WEBPACK FOOTER //
// ./src/api/baseUrl.js